
import HttpClient from '../HttpService';

function list(page, limit, data) {
    return HttpClient.post(`/events/list?page=${page}&limit=${limit}`, data);
}

function getByUuid(uuid) {
    return HttpClient.get(`/events/${uuid}`);
}

function create(data) {
    return HttpClient.post(`/events`, data);
}

function update(uuid, data) {
    return HttpClient.put(`/events/${uuid}`, data);
}

function destroy(uuid) {
    return HttpClient.delete(`/events/${uuid}`);
}

function restore(uuid) {
    return HttpClient.post(`/events/${uuid}/restore`);
}

function getPublic(uuid) {
    return HttpClient.get(`/events/public/${uuid}`);
}

function register(uuid, payload) {
    return HttpClient.post(`/events/${uuid}/register`, payload);
}

function listParticipants(uuid, page = 1, limit = 15, search) {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (search) params.set('search', search);
    return HttpClient.get(`/events/${uuid}/participants?${params.toString()}`);
}

function addParticipant(uuid, data) {
    return HttpClient.post(`/events/${uuid}/participants`, data);
}

function updateParticipant(uuid, participantUuid, data) {
    return HttpClient.put(`/events/${uuid}/participants/${participantUuid}`, data);
}

function downloadCertificate(uuid, participantUuid) {
    return HttpClient.get(`/events/${uuid}/participants/${participantUuid}/certificate`, { responseType: 'blob' });
}

function deleteParticipant(uuid, participantUuid) {
    return HttpClient.delete(`/events/${uuid}/participants/${participantUuid}`);
}

function sendCertificates(uuid) {
    return HttpClient.post(`/events/${uuid}/certificates/send`);
}

function sendParticipantCertificate(uuid, participantUuid) {
    return HttpClient.post(`/events/${uuid}/participants/${participantUuid}/certificate/send`);
}

function downloadInsights(uuid, company) {
    const params = company ? { params: { company }, responseType: 'blob' } : { responseType: 'blob' };
    return HttpClient.get(`/events/${uuid}/insights`, params);
}

function getInsightsData(uuid) {
    return HttpClient.get(`/events/${uuid}/insights-data`);
}

function validateCertificate(code) {
    return HttpClient.get(`/events/certificate/validate/${code}`);
}

export default {
    list,
    getByUuid,
    create,
    update,
    destroy,
    restore,
    getPublic,
    register,
    listParticipants,
    addParticipant,
    updateParticipant,
    deleteParticipant,
    downloadCertificate,
    sendCertificates,
    sendParticipantCertificate,
    downloadInsights,
    getInsightsData,
    validateCertificate
}
